import { createContext } from "react";

const ComponentHeroContext = createContext(null);

export { ComponentHeroContext };
